import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";
  import { formatDate } from "@/helpers/date";
  import { removeEmptyEntries } from "@/helpers/removeEmptyEntries";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'LotConditions',
  props: {
    lot: {
      type: Object,
      required: true,
    },
  },
  setup(__props, { expose: __expose }) {
  __expose();

  const props = __props;

  const checkFinanceBrokerDetails = computed(() => {
    return (
      props.lot?.eoiId?.contractConditions?.financeBrokerDetails &&
      Object.keys(
        removeEmptyEntries(
          props.lot?.eoiId?.contractConditions?.financeBrokerDetails
        )
      ).length
    );
  });

  const getContractConditionsFields = (field: string) => {
    const contractConditions = props.lot?.eoiId?.contractConditions;

    if (contractConditions && field in contractConditions) {
      return contractConditions[field] ? "Yes" : "No";
    }

    return "-";
  };

const __returned__ = { props, checkFinanceBrokerDetails, getContractConditionsFields, computed, get formatDate() { return formatDate }, get removeEmptyEntries() { return removeEmptyEntries } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})